import { ReactElement, cloneElement } from 'react';
import { modalsVar } from '../../variables';
import { ModalProps } from './Modal';
export * from './Modal';
export { default } from './Modal';

export function showModal(modal: ReactElement<ModalProps>) {
  const {
    props: { onClose },
  } = modal;

  const randomId = Math.random().toString(36).substring(2, 15);
  const key = `${+new Date()}-${randomId}`;

  const clonedModal = cloneElement(modal, {
    key,
    onClose: () => {
      const currentModals = modalsVar();
      const newModals = currentModals.filter((m) => m.key !== key);
      modalsVar(newModals);
      onClose?.();
    },
  });

  modalsVar([...modalsVar(), clonedModal]);
}

export function closeModals() {
  modalsVar([]);
}
